module.exports = __webpack_public_path__ + "static/img/9.afd32b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/9.jpg
// module id = SV3b
// module chunks = 1